<section aria-labelledby="cursos-title">
  <div #scrollContainer class="tela-cursos-concluidos" (scroll)="onScroll()">
    <div class="lista-tipos">
      <span *ngFor="let tag of Object.keys(cursosTraduzidos)" (click)="navegarParaTag(tag)" tabindex="0" role="button" [attr.aria-label]="'Navegar para ' + tag">
        <img [src]="'assets/techs/' + limparNomeTag(tag) + '.png'" alt="{{ tag }} icon" class="icon">
        {{ tag }}
      </span>
    </div>
    <div *ngFor="let tag of Object.keys(cursosTraduzidos)">
      <h4 id="{{tag}}" class="lista-tag">{{tag}}</h4>
      <ul>
        <li *ngFor="let curso of cursosTraduzidos[tag]" class="curso-item">
          <div class="curso-info" title="{{ curso.nome}} - {{ curso.instituicao }} - {{ curso.duracao }}h - {{ curso.dataConclusao }}">
            <span>{{ curso.nome }}&nbsp;</span>
            <span class="curso-duracao"><span class="separador"> -&nbsp;</span>{{ curso.duracao }}h</span>
          </div>
        </li>
      </ul>
    </div>
  </div>
  <app-container-botao [isScrollAtTop]="isScrollAtTop" (voltarHome)="onVoltarHome()" (scrollToTop)="scrolltoTop()"></app-container-botao>
</section>
